import { render, staticRenderFns } from "./OrderMedia.vue?vue&type=template&id=b50fd966&scoped=true&"
import script from "./OrderMedia.vue?vue&type=script&lang=js&"
export * from "./OrderMedia.vue?vue&type=script&lang=js&"
import style0 from "./OrderMedia.vue?vue&type=style&index=0&id=b50fd966&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b50fd966",
  null
  
)

export default component.exports